import { ProfileListContent } from 'ui/components/ProfileListContent'

export const ProfileList = () => <ProfileListContent />
